import React from "react";
import { Card, Table } from "react-bootstrap";

// Supervisor Leaderboard Table (original style)
const LeaderboardTable = ({ data }) => {
  return (
    <Card className="p-3 shadow-sm">
      <div style={{ overflowX: "auto" }}>
        <Table bordered hover responsive className="mb-0 text-center">
          <thead>
            <tr style={{ backgroundColor: "#6C6DC6", color: "white" }}>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Top Rankers
              </th>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Points
              </th>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Department Name
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#eeeeee",
                }}
              >
                <td>{item?.rank}</td>
                <td>{item?.totalScore}</td>
                <td>{item?.department}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Card>
  );
};

// Employee Leaderboard Table (new style matching supervisor format)
const EmployeeLeaderboardTable = ({ data }) => {
  return (
    <Card className="p-3 shadow-sm">
      <div style={{ overflowX: "auto" }}>
        <Table bordered hover responsive className="mb-0 text-center">
          <thead>
            <tr style={{ backgroundColor: "#6C6DC6", color: "white" }}>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Rank
              </th>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Employee Name
              </th>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Points
              </th>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Department
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#eeeeee",
                }}
              >
                <td>{item?.rank}</td>
                <td className="text-capitalize">{item?.employeeName}</td>
                <td>{item?.totalExpertise}</td>
                <td>{item?.department}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Card>
  );
};

// Supervisor Leaderboard Table (all supervisors across managers)
const SupervisorLeaderboardTable = ({ data }) => {
  return (
    <Card className="p-3 shadow-sm">
      <div style={{ overflowX: "auto" }}>
        <Table bordered hover responsive className="mb-0 text-center">
          <thead>
            <tr style={{ backgroundColor: "#6C6DC6", color: "white" }}>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Rank
              </th>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Supervisor Name
              </th>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Points
              </th>
              <th style={{ backgroundColor: "#6C6DC6", color: "white" }}>
                Manager
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#eeeeee",
                }}
              >
                <td>{item?.rank}</td>
                <td className="text-capitalize">{item?.supervisorName}</td>
                <td>{item?.totalScore}</td>
                <td className="text-capitalize">{item?.managerName}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Card>
  );
};

export {
  LeaderboardTable,
  EmployeeLeaderboardTable,
  SupervisorLeaderboardTable,
};